import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import Grid from "@mui/material/Grid";

// Assets
import {blueColor, greyishBlue500} from "assets/jss/main";
import WMSCarrierIcon from "../../../../../../../../../components/WMS/WMSCarrierIcon";

SpecialOrderItem.propTypes = {
    order: PropTypes.object.isRequired,
    shipmentIndex: PropTypes.number.isRequired
};

function SpecialOrderItem({order, shipmentIndex}) {
    const shipment = order.shipments[shipmentIndex];
    const shippingMethod = shipment?.shippingMethod;

    return (
        <Grid container flexDirection={'row'} xs={12}>
            <Grid item sx={{margin: 'auto 8px', height: 'fit-content', padding: 0}}>
                {shippingMethod?.carrierIcon && (
                    <WMSCarrierIcon
                        iconName={shippingMethod?.carrierIcon}
                        altName={'alt'}
                        width={16}
                        height={16}
                    />
                )}
            </Grid>
            <Grid item container direction={'column'} xs>
                {shipment?.externalDeliveryNumber && (
                    <Grid
                        item
                        sx={{
                            fontSize: '12px',
                            color: greyishBlue500
                        }}
                    >
                        <FormattedMessage id='wms.packing.specialOrder.externalDeliveryNumber' /> : {shipment.externalDeliveryNumber}
                    </Grid>
                )}
                <Grid
                    container
                    sx={{
                        fontWeight: '600',
                        color: blueColor,
                    }}
                    gap={"8px"}
                >
                    <span>#{order?.displayExternalId}</span> <span style={{color: greyishBlue500, fontWeight:"normal"}}>({shipment.shippingMethod.name})</span>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default SpecialOrderItem;
